<div id="monitoring" class="page-layout blank">

    <div class="main-widget">

        <div class="position-relative p-24 blue-600" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="column" fxLayoutAlign="start start">
                <span class="h2">Monitoring</span>
            </div>

        </div>


    </div>

    <div class="content">
        <p-toast [showTransformOptions]="'translateX(100%)'"></p-toast>

        <div class="left mr-lg-32">

            <div class="pb-24 font-size-18 font-weight-300">
                DiskSpace
            </div>

            <div class="fuse-card auto-width p-16">

                <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">

                    <!-- Widget 2 -->
                    <div class="widget" fxFlex="100" fxFlex.gt-sm="33">

                        <div class="fuse-card auto-width mb-32" [ngClass.gt-sm]="'mb-0 mr-32'">

                            <div class="p-16 box" fxLayout="row wrap" fxLayoutAlign="start end">

                                <div class="pr-16">
                                    <div class="h3 secondary-text">Total</div>
                                    <div class="font-size-36 font-weight-300 line-height-1 mt-8">
                                        {{totalDiskSpace}}
                                    </div>
                                </div>

                                <!-- <div class="py-4 font-size-16" fxLayout="row" fxLayoutAlign="start center">
                                <div fxFlex="row" fxLayoutAlign="start center" class="green-fg">
                                    <mat-icon class="green-fg mr-4">trending_up</mat-icon>
                                    <span>13%</span>
                                </div> -->
                                <!-- <div fxFlex="row" fxLayoutAlign="start center" class="red-fg"
                                    >
                                    <mat-icon class="red-fg mr-4">trending_down</mat-icon>
                                    <span>13%</span>
                                </div> -->
                                <!-- <div class="ml-4 text-nowrap">of target</div>
                            </div> -->

                            </div>

                        </div>

                    </div>
                    <!-- / Widget 2 -->

                    <!-- Widget 3 -->
                    <div class="widget" fxFlex="100" fxFlex.gt-sm="34">

                        <div class="fuse-card auto-width mb-32" [ngClass.gt-sm]="'mb-0 mr-32'">

                            <div class="p-16 box" fxLayout="row wrap" fxLayoutAlign="start end">

                                <div class="pr-16">
                                    <div class="h3 secondary-text">Free</div>
                                    <div class="font-size-36 font-weight-300 line-height-1 mt-8">
                                        {{freeDiskSpace}}
                                    </div>
                                </div>



                            </div>

                        </div>

                    </div>
                    <!-- / Widget 3 -->



                </div>
            </div>



            <!-- Widget 6 -->
            <div class="pt-48 pb-24 font-size-18 font-weight-300">
                Actuator
            </div>

            <div class="fuse-card auto-width p-16">


                <div class="p-16" fxLayout="row" fxLayoutAlign="space-between center">
                    <div class="h1 pr-16">Actuator links</div>
                </div>

                <table class="simple clickable">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Link</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of actuators" (click)="loadActuatorNewWindow(row.href)">
                            <td>{{row.name}}</td>
                            <td>{{row.href}}</td>
                            <td>
                                <div fxFlex="row" fxLayoutAlign="end center" *ngIf="row.name == 'metrics'">

                                    <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More"
                                        (click)="$event.stopPropagation();">
                                        <mat-icon class="secondary-text">more_vert</mat-icon>
                                    </button>
                                    <mat-menu #moreMenu="matMenu">
                                        <div *ngFor="let m of metrics">
                                            <button mat-menu-item (click)="loadActuatorNewWindow(row.href+'/'+m)">
                                                <span>{{m}}</span>
                                            </button>
                                        </div>
                                    </mat-menu>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>



            </div>
            <!-- / Widget 6 -->

        </div>

        <div class="right">

            <div fxLayout="row wrap" fxLayout.gt-md="column">

                <!-- Widget 7 -->
                <div class="mb-48" [ngClass.lt-lg]="'mr-32'" [ngClass.xs]="'mr-0'">

                    <div class="pb-24 font-size-18 font-weight-300">
                        Memory Info
                    </div>

                    <div class="fuse-card">

                        <div class="p-16">
                            <div class="h1 font-weight-300">Memory</div>
                        </div>

                        <div class="h-200">
                            <ngx-charts-pie-chart *ngIf="memory.length > 1" [scheme]="colorChart" [results]="memory"
                                [doughnut]="true"></ngx-charts-pie-chart>
                        </div>

                        <div class="p-16" fxLayout="row" fxLayoutAlign="center center">

                            <div class="px-16" fxLayout="column" fxLayoutAlign="start center" *ngFor="let m of memory">

                                <div class="h4 secondary-text">{{m.name}}</div>
                                <div class="h2 font-weight-300 py-8">{{m.unite}}</div>

                            </div>

                        </div>



                    </div>

                </div>
                <!-- / Widget 7 -->

                <!-- Widget 8 -->
                <div class="mb-48" [ngClass.lt-lg]="'mr-32'" [ngClass.xs]="'mr-0'">

                    <div class="fuse-card">

                        <div class="light-blue-600">

                            <div class="p-16" fxLayout="row" fxLayoutAlign="space-between center">
                                <div class="pr-16">
                                    <div class="h1 font-weight-300">Important Tasks</div>
                                </div>
                            </div>

                            <div class="p-16 pt-8">
                               <div class="row">
                                    <button mat-button (click)="syncPrivilege()">
                                        Update Privileges</button>
                                </div>
                               <div class="row">
                                    <button mat-button (click)="purgeActionLogs()">
                                        Purge Action Logs</button>
                                </div>
                                <div class="row">
                                    <button mat-button (click)="loadActuatorNewWindow(urlLogFile, 'text' )">Current Log
                                        File</button>
                                </div>
                                <div class="row">
                                    <button mat-button (click)="downloadLogs()">Download Logs</button>
                                </div>
                                <div class="row">
                                    <button mat-button (click)="downloadDump()">Backup Database</button>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

                <!-- / Widget 8 -->

            </div>

        </div>

    </div>

</div>